var moment = require('moment');
var haversine = require('haversine');

var _parent = {};
const log = false;

var utilities = {
  init: p => (_parent = p),

  // TODO- function to validate street address format
  /**
   * Validates that inputs are strings
   * @param {Array} inputs- Array of inputs to validate
   * @returns true for valid items, false for invalid
   */
  isString(inputs) {
    for (i = 0; i < inputs.length; i++) {
      if (typeof inputs[i] !== 'string') {
        return false;
      }
    }
    return true;
  },
  /**
   * Used to validate that ids are defined and numbers
   * @param {Array} inputs- Array of inputs to validate
   * @returns true for valid items, false for invalid
   */
  isNumber(inputs) {
    for (i = 0; i < inputs.length; i++) {
      if (typeof inputs[i] !== 'number') {
        return false;
      }
    }
    return true;
  },
  /**
   * Validates that addresses are strings
   * @param {Array} inputs- Array of inputs to validate
   * @param {Number} minimum- minimum length of inputs
   * @returns true for valid items, false for invalid
   */
  isLength(inputs, minimum) {
    for (i = 0; i < inputs.length; i++) {
      if (inputs[i].length < minimum) {
        return false;
      }
    }
    return true;
  },

  /** Round a number with a precision */
  round: (num = null, precision = 0) => {
    if (num) {
      const multiplier = Math.pow(10, precision);
      const output = Math.round(num * multiplier) / multiplier;
      return output;
    }
    return 0;
  },

  roundToTenth: function (num) {
    var roundNum = Math.round(num * 10) / 10;
    return roundNum;
  },

  roundToHundreth: function (num) {
    var roundNum = Math.round(num * 100) / 100;
    return roundNum;
  },

  /**
   * Returns street number and name from address
   *
   * @param {String} addressString
   */
  splitStreetNumberAndName: function (addressString) {
    let splitAddress = addressString.split(' ');
    let streetNumberAndName = splitAddress.slice(0, 3).join(' ');
    return streetNumberAndName;
  },

  /**
   * Convert a miles per hour number to meters per second
   *
   * @param  {int} mph - Miles per hour value to convert to miles per second (ex: 40 mph)
   * @return  {int} mps - Resulting meters per second after conversion
   */
  convertMphToMps: function (mph) {
    return mph / 2.237;
  },

  /**
   * Convert a number of miles to meters
   *
   * @param  {int} miles - Miles value to convert to meters (ex: 6.6 mi)
   * @return  {int} meters - Resulting meters after conversion
   */
  convertMilesToMeters: function (miles) {
    return miles * 1609.344;
  },

  /**
   * Calculate the total drive time as seconds based on a specified
   * miles per hour speed
   *
   * @param  {int} miles - The number of miles distance (ex: 6.6 mi)
   * @param  {int} avgMph - The average speed of travel (ex: 40 mph)
   * @return  {int} driveTime - Resulting drive time in seconds
   */
  getDriveTimeAsSeconds: function (miles, avgMph) {
    let metersPerSecond = utilities.convertMphToMps(avgMph);
    let meters = utilities.convertMilesToMeters(miles);
    return Math.round(meters / metersPerSecond);
  },

  /**
   * Get an ISO timestamp string of the current date using
   * midnight for the time. This simply uses zeros for the
   * hour minute and second when building the ISO string,
   * so be careful when using near midnight of the
   * current date that it behaves as you wish.
   *
   * @param {Date} [date=new Date()] - The date to use as the basis for the iso formatting
   */
  formatDateFromMidnightWithTimezoneAsISO: function (date) {
    //If the data param is not a Date() object then default to today
    var dt = date instanceof Date && !isNaN(date) ? date : new Date();
    var tzo = -dt.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num) {
        var norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
      };
    return (
      dt.getFullYear() +
      '-' +
      pad(dt.getMonth() + 1) +
      '-' +
      pad(dt.getDate()) +
      'T' +
      pad(0) +
      ':' +
      pad(0) +
      ':' +
      pad(0) +
      dif +
      pad(tzo / 60) +
      ':' +
      pad(tzo % 60)
    );
  },

  /**
   * Return the date formated as a ISO string with the Z for zulu
   * on the end replaced with the current timezone offset from the
   * system running the code.
   *
   * @param {Date} [date=new Date()] - The date to get the format for
   * @param {Number} [offset=Date.prototype.getTimezoneOffset()] - The timezone offset to apply in seconds
   */
  getLocalISOString: function (date, offset) {
    //If the data param is not a Date() object then default to today
    var dt = date instanceof Date && !isNaN(date) ? date : new Date();
    //Get the offset in milliseconds with optional param override
    var off = offset ? offset : new Date().getTimezoneOffset();
    return new Date(dt.getTime() - off * 60 * 1000).toISOString().slice(0, -1) + utilities.timezoneOffsetISOString(off); // => '2015-01-26T06:40:36.181-05:00'
  },

  /**
   * Return the date passed in with the number of minutes added to it.
   *
   * @param {Date} [date=new Date()] - The date to get the format for
   * @param {Date} [date=new Date()] - The date to get the format for
   * @param {Number} [offset=Date.prototype.getTimezoneOffset()] - The timezone offset to apply in seconds
   */
  addMinutes: function addMinutes(minutes, date) {
    if (typeof minutes !== 'number') throw 'Minutes must be a number';
    var dt = date instanceof Date && !isNaN(date) ? date : new Date();
    return new Date(dt.getTime() + minutes * 60000);
  },

  /**
   * Get the human readable -00:00 format of a timezone offset for
   * use on the end of a date iso string.
   *
   * @param {Number} [offset=Date.prototype.getTimezoneOffset()] - The timezone offset to apply
   */
  timezoneOffsetISOString: function (offset) {
    //Get the offset in milliseconds with optional param override
    var off = offset ? offset : new Date().getTimezoneOffset();
    const absoff = Math.abs(off);
    return (
      (off > 0 ? '-' : '+') +
      (absoff / 60).toFixed(0).padStart(2, '0') +
      ':' +
      (absoff % 60).toString().padStart(2, '0')
    );
  },

  /**
   * Simple money round to nearest penny. We shouldn't rely on
   * this for all financial math but get serious about it and
   * use a library like https://github.com/dinerojs/dinero.js
   * when we are doing heavy financial calcs like rewriting AR
   *
   * @param  {Number} number - Value to be rounded to nearest penny
   * @return  {Number} number - Rounded number
   */
  roundToNearestPenny: function (value) {
    return Math.ceil(value * 100) / 100;
  },

  /** Convert all strings from CDK into proper case (only first letter capitalized)
   * @param {String} string - uppercase string
   * @return {String} proper case string
   */
  toProperCase: function (string) {
    let upperCaseString = string.toUpperCase();
    let properCaseString = upperCaseString[0] + upperCaseString.substring(1).toLowerCase();
    return properCaseString;
  },

  /**
   * Got this from stackoverflow:
   *   https://stackoverflow.com/questions/33036487/one-liner-to-flatten-nested-object
   *
   * Flatten a multidimensional object
   *
   * For example:
   *   flattenObject({ a: 1, b: { c: 2 } })
   * Returns:
   *   { a: 1, c: 2}
   */
  flattenObject: function (obj) {
    const flattened = {};
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(flattened, this.flattenObject(obj[key]));
      } else {
        flattened[key] = obj[key];
      }
    });
    return flattened;
  },

  /*!
   * Find the differences between two objects and push to a new object
   * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
   * @param  {Object} obj1 The original object
   * @param  {Object} obj2 The object to compare against it
   * @return {Object}      An object of differences between the two
   */
  diff: (obj1, obj2) => {
    // Make sure an object to compare is provided
    if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
      return obj1;
    }

    //
    // Variables
    //

    var diffs = {};
    var key;

    //
    // Methods
    //

    /**
     * Check if two arrays are equal
     * @param  {Array}   arr1 The first array
     * @param  {Array}   arr2 The second array
     * @return {Boolean}      If true, both arrays are equal
     */
    var arraysMatch = function (arr1, arr2) {
      // Check if the arrays are the same length
      if (arr1.length !== arr2.length) return false;

      // Check if all items exist and are in the same order
      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      }

      // Otherwise, return true
      return true;
    };

    /**
     * Compare two items and push non-matches to object
     * @param  {*}      item1 The first item
     * @param  {*}      item2 The second item
     * @param  {String} key   The key in our object
     */
    var compare = function (item1, item2, key) {
      // Get the object type
      var type1 = Object.prototype.toString.call(item1);
      var type2 = Object.prototype.toString.call(item2);

      // If type2 is undefined it has been removed
      if (type2 === '[object Undefined]') {
        diffs[key] = null;
        return;
      }

      // If items are different types
      if (type1 !== type2) {
        diffs[key] = item2;
        return;
      }

      // If an object, compare recursively
      if (type1 === '[object Object]') {
        var objDiff = utilities.diff(item1, item2);
        if (Object.keys(objDiff).length > 1) {
          diffs[key] = objDiff;
        }
        return;
      }

      // If an array, compare
      if (type1 === '[object Array]') {
        if (!arraysMatch(item1, item2)) {
          diffs[key] = item2;
        }
        return;
      }

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (type1 === '[object Function]') {
        if (item1.toString() !== item2.toString()) {
          diffs[key] = item2;
        }
      } else {
        if (item1 !== item2) {
          diffs[key] = item2;
        }
      }
    };

    //
    // Compare our objects
    //

    // Loop through the first object
    for (key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        compare(obj1[key], obj2[key], key);
      }
    }

    // Loop through the second object and find missing items
    for (key in obj2) {
      if (obj2.hasOwnProperty(key)) {
        if (!obj1[key] && obj1[key] !== obj2[key]) {
          diffs[key] = obj2[key];
        }
      }
    }

    // Return the object of differences
    return diffs;
  },

  //Nested property helper (the double equals is necessary)
  getPropValue: (obj, key) => key.split('.').reduce((o, x) => (o == undefined ? o : o[x]), obj),

  //Compare the structure of two objects without comparing values (used for testing)
  compareObjectStructure: (object1, object2) => {
    for (i in object1)
      if (!object2.hasOwnProperty(i)) {
        return false;
      } else if (typeof object1.i === 'object' && typeof object2.i === 'object') {
        compareObjectStructure(object1.i, object2.i);
      }
    return true;
  },

  /**
   * Validates that address is correct type and formatted in a way google API can use
   *
   * @param  {String} address - Minimum requirements are Street Address, City, and State
   * @returns {Boolean} - true if valid, false if not
   *
   */
  validateAddress: function (address) {
    //Validate type
    if (typeof address !== 'string') {
      return false;
    }
    //Validate that address looks like an address (numbers and letters in correct spots)
    //NOTE: this section can likely be improved
    //  Alt regex: ^[#.0-9a-zA-Z\s,-]+$ (checks that string only contains letters, numbers, comma, periods, - and #)
    let alphaRegex = /.*[a-zA-Z]+.*/;
    let numRegex = /.*[0-9]+.*/;
    //If no numbers, address is missing address number
    if (!(address.match(alphaRegex) && address.match(numRegex))) {
      return false;
    }
    //Validate length and that address contains commas between components of address
    let commaSplitAddress = address.split(',');
    if (commaSplitAddress.length < 3) {
      return false;
    } else {
      return true;
    }
    //NOTE: we could add more validation
    // for example checking the order of letters and numbers
    // but at this point that seems like overkill
  },

  /**
   * Default validation object structure from validateAndCleanseObject()
   *
   * @param {object|array} input - The unvalidated object/array
   * @param {object|array} output - The validated object/array
   * @returns {object} Structured return object that determines success or failure and logs events
   */

  defaultValidation: (input = null, output = null) => {
    let validation = {
      success: true,
      modified: false,
      input: input,
      output: output,
      logs: [],
      errors: [],
    };
    return validation;
  },

  /**
   * Validate an object against a schema
   *
   * SCHEMA STRUCTURE:
   *
   * schemaName: {
   *   fieldName: {
   *     isValid: Function that takes in the field's input value and returns true or false based on validity,
   *     required: Boolean that determines if the field is required (Optional, Default = false),
   *     invalidFallback: Boolean to determine if the default fallback should be used if the field is invalid (Optional, Default = false),
   *     missingFallback: Boolean to determine if the default fallback should be used if the field is missing (Optional, Default = true),
   *     default: Fallback value if field is not valid or if field is required but missing (Optional),
   *     cleanse: Function that takes in the field's input value and cleanses it (Optional),
   *     customError: String that gets returned when validation fails on this field (Optional),
   *   }
   * }
   *
   * @param {object} input - A partial or complete object to validate
   * @param {object} schema - Schema object to validate against
   * @param {string} objKey - (Optional) String that specifies the object name (utilize if validating multiple objects)
   * @param {boolean} trim - (Optional, Default = true) Boolean to determine if excess fields should be trimmed/removed
   * @returns {object} Structured return object that determines success or failure and logs events
   */

  validateAndCleanseObject: (input, schema, objKey = null, trim = true) => {
    // Setup default return properties
    let success = true;
    let modified = false;
    let output = { ...input };
    let logs = [];
    let errors = [];
    const objKeyStr = objKey ? ` for ${objKey}` : ``;

    try {
      // If trimming is allowed
      if (trim === true) {
        // Collect keys from the input
        // Filter to find any input fields that don't exist in the schema
        // Map over each non-existent property to trim/remove them from the output
        Object.keys(input)
          .filter(key => !schema.hasOwnProperty(key))
          .map(key => {
            delete output[key];
            logs.push(`Excess field '${key}'${objKeyStr} was removed since the property does not exist in the schema.`);
          });
      }

      // Collect keys from the schema
      // Filter to find any property value that may seem invalid
      // Map over each possible invalid property value and determine if it is truly invalid or just missing
      Object.keys(schema)
        .filter(key => !schema[key].isValid(input[key]))
        .map(key => {
          // If the invalid value exists, the property value is invalid (it wouldn't have made it to this conditional otherwise)
          // If there is a default, update the property value to that, but only if the schema allows it
          // Else fail the validation
          if (input[key]) {
            if (schema[key].hasOwnProperty(`default`) && schema[key].invalidFallback === true) {
              output[key] = schema[key].default;
              logs.push(`Field '${key}'${objKeyStr} was invalid. Changed to default of '${schema[key].default}'.`);
            } else {
              success = false;
              errors.push(
                _parent.errors.buildValidationError(
                  _parent.errors.codes.FIELD_INVALID,
                  schema[key].customError ? schema[key].customError : `Field '${key}'${objKeyStr} is invalid.`
                )
              );
            }
          }

          // If the schema requires a value, but it doesn't exist, the property value is missing
          // If there is a default, update the property value to that, but only if the schema allows it
          // Else fail the validation
          if (!input[key] && schema[key].required && schema[key].missingFallback !== false) {
            if (schema[key].hasOwnProperty(`default`)) {
              output[key] = schema[key].default;
              logs.push(`Field '${key}'${objKeyStr} was missing. Added default of '${schema[key].default}'.`);
            } else {
              success = false;
              errors.push(
                _parent.errors.buildValidationError(
                  _parent.errors.codes.FIELD_MISSING,
                  schema[key].customError
                    ? schema[key].customError
                    : `Field '${key}'${objKeyStr} is missing. This field is required and has no default fallback value.`
                )
              );
            }
          }
        });

      // Collect keys from the schema
      // Filter to find any property value that has a cleansing function
      // Map over each cleansing function and apply the change to the output
      Object.keys(schema)
        .filter(key => schema[key].hasOwnProperty(`cleanse`))
        .map(key => {
          if (output[key]) {
            let cleansedValue = schema[key].cleanse(output[key]);
            output[key] = cleansedValue;
            logs.push(`Field '${key}'${objKeyStr} was cleansed. Output: '${cleansedValue}'.`);
          }
        });

      // Check if the input was modified by this validation function
      if (JSON.stringify(input) !== JSON.stringify(output)) modified = true;
    } catch (err) {
      success = false;
      errors.push(
        _parent.errors.buildApiError(
          _parent.errors.codes.UNKNOWN,
          `An unexpected error has occurred while processing the request validation.`
        )
      );
      console.error(`validateAndCleanseObject() - Validation has failed due to an unexpected error:`, err);
    }

    // Structured return object
    return {
      success: success, // Success bool to indicate pass/fail of validation
      modified: modified, // Modified bool to indicate that the output was modified
      input: input, // Initial input object (OLD)
      output: output, // Validated/corrected/cleansed output object (NEW)
      logs: logs, // Logs stating why the move was invalid and what was corrected
      errors: errors, // Errors that caused the validation to fail
    };
  },

  /**
   * Cleanse a Date() to keep it consistent across our database
   *
   * @param {string} stamp - A timestamp in ms to cleanse
   * @returns {string} Returns a consistent timestamp string
   */
  cleanseTimestamp: stamp => {
    let dateObj = new Date(stamp);

    let year = `${dateObj.getUTCFullYear()}`.padStart(4, `0`);
    let month = `${dateObj.getUTCMonth() + 1}`.padStart(2, `0`);
    let day = `${dateObj.getUTCDate()}`.padStart(2, `0`);
    let hour = `${dateObj.getUTCHours()}`.padStart(2, `0`);
    let minute = `${dateObj.getUTCMinutes()}`.padStart(2, `0`);
    let second = `${dateObj.getUTCSeconds()}`.padStart(2, `0`);
    let millisecond = `${dateObj.getUTCMilliseconds()}`.padStart(3, `0`);

    let cleansedStamp = `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}+00:00`;
    return cleansedStamp;
  },

  /**
   * Cleanse a timestamp to keep it consistent across our database
   *
   * @param {string} stamp - A timestamp string to cleanse
   * @returns {string} Returns a consistent timestamp string
   */
  cleanseTimestamp: stamp => moment.utc(moment(stamp)).format(`YYYY-MM-DDTHH:mm:ss.SSSZ`),

  /**
   * Timestamp for now
   *
   * @returns {string} Returns a consistent timestamp string
   */
  now: () => moment.utc(moment()).format(`YYYY-MM-DDTHH:mm:ss.SSSZ`),

  /**
   * Timestamp for now plus(+) a set number of minutes
   *
   * @param {string} minsToAdd - Minutes to add to the timestamp
   * @returns {string} Returns a consistent timestamp string
   */
  nowPlus: minsToAdd => moment.utc(moment().add(minsToAdd, `minutes`)).format(`YYYY-MM-DDTHH:mm:ss.SSSZ`),

  /**
   * Timestamp for now minus(-) a set number of minutes
   *
   * @param {string} minsToSub - Minutes to subtract from the timestamp
   * @returns {string} Returns a consistent timestamp string
   */
  nowMinus: minsToSub => moment.utc(moment().subtract(minsToSub, `minutes`)).format(`YYYY-MM-DDTHH:mm:ss.SSSZ`),

  /**
   * Use haversine formula on two lat-long coordinates to calculate a "as the crow flies" distance
   * NPM package link: https://www.npmjs.com/package/haversine
   *
   * @param {Array} start - latitude and longitude of starting location
   * @param {Array} end - latitude and longitude of destination location
   * @param {Int} averageMPH - The estimated average speed between destinations (default 20)
   * @returns {Int} the estimated duration in seconds between the two coords
   */
  estimateDuration: (start, destination, averageMPH = 20) => {
    const estimatedDistance = haversine(start, destination, { unit: 'mile', format: '[lat,lon]' });
    log && console.log('distance', estimatedDistance);
    const estimatedDurationInHours = estimatedDistance / averageMPH;
    const estimatedDurationInSeconds = Math.ceil(estimatedDurationInHours * 3600);
    log && console.log('duration', estimatedDurationInSeconds);
    return estimatedDurationInSeconds;
  },

  /**
   * Take in old and new versions of objects and return version with only different values
   *
   * @param {Object} oldObject - Object before update
   * @param {Object} newObject - Object after update
   * @returns {Object} Object contatining only changed new and old values
   */
  objectsBeforeAndAfter: (oldObject, newObject) => {
    //clone spread
    let objOne = { ...oldObject };
    let objTwo = { ...newObject };

    for (var k in objOne) {
      if (objOne[k] === objTwo[k]) {
        delete objOne[k];
        delete objTwo[k];
      }
    }
    return { old: objOne, new: objTwo };
  },

  /** Capitalize the first letter of the first word */
  capFirst: (str = null) => {
    if (str && typeof str === `string`) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return str;
  },

  /** Capitalize the first letter of each word */
  capEach: (str = null) => {
    if (str && typeof str === `string`) {
      if (!str.includes(` `)) return str.charAt(0).toUpperCase() + str.slice(1);
      else {
        let arr = str.split(` `);
        arr = arr.map(s => s.charAt(0).toUpperCase() + s.slice(1));
        return arr.join(` `);
      }
    }
    return str;
  },

  /** Capitalize every letter of every word */
  capAll: (str = null) => {
    if (str && typeof str === `string`) {
      return str.toUpperCase();
    }
    return str;
  },

  /** Get the region id from a move - From the lane's pickup or delivery */
  getRegionIdFromMove: (move = null) => {
    if (move) {
      const regionId =
        _parent.utilities.getPropValue(move, `lane.pickup.region_id`) ||
        _parent.utilities.getPropValue(move, `lane.pickup.region.id`) ||
        _parent.utilities.getPropValue(move, `lane.delivery.region_id`) ||
        _parent.utilities.getPropValue(move, `lane.delivery.region.id`);
      return regionId || null;
    }
    return null;
  },

  /** Get the region id from a move - From the lane's pickup or delivery */
  getRegionNameFromMove: (move = null) => {
    if (move) {
      const regionName =
        _parent.utilities.getPropValue(move, `lane.pickup.region.name`) ||
        _parent.utilities.getPropValue(move, `lane.delivery.region.name`);
      return regionName || null;
    }
    return null;
  },

  /**
   * Converts a weight in pounds into an integer representing a Federal Highway Administration vehicle class
   * https://afdc.energy.gov/data/10380
   * @param {Int} weight defaults to 0
   * @returns Integer representing the vehicle class
   */
  getVehicleClassNumberFromWeight: (weight = 0) => {
    if (weight <= 6000) return 1;
    else if (weight <= 10000) return 2;
    else if (weight <= 14000) return 3;
    else if (weight <= 16000) return 4;
    else if (weight <= 19500) return 5;
    else if (weight <= 26000) return 6;
    else if (weight <= 33000) return 7;
    else return 8;
  },

  /** Generate a list of private step ids from a workflowset */
  getPrivateStepIds: (workflowset = null) => {
    /** Recursively find and build an array of private workflow steps */
    const findPrivateSteps = (privateSteps, stepsToSearch) => {
      if (!stepsToSearch || !stepsToSearch.length) return privateSteps;
      for (let i = 0; i < stepsToSearch.length; i++) {
        const currentStep = stepsToSearch[i];
        if (currentStep.config && currentStep.config.private) privateSteps.push(currentStep);
        if (currentStep.steps && currentStep.steps.length) {
          privateSteps = findPrivateSteps(privateSteps, currentStep.steps);
        }
      }
      return privateSteps;
    };

    // If we don't have a workflowset, return an empty array
    if (!workflowset) return [];

    // Initialize an array to hold private steps
    let privateSteps = [];

    // Dig through pickup workflow
    if (workflowset.pickupWorkflow && workflowset.pickupWorkflow.steps && workflowset.pickupWorkflow.steps.length) {
      privateSteps = findPrivateSteps(privateSteps, workflowset.pickupWorkflow.steps);
    }

    // Dig through delivery workflow
    if (
      workflowset.deliveryWorkflow &&
      workflowset.deliveryWorkflow.steps &&
      workflowset.deliveryWorkflow.steps.length
    ) {
      privateSteps = findPrivateSteps(privateSteps, workflowset.deliveryWorkflow.steps);
    }

    // Dig through fuel workflow
    if (workflowset.fuelWorkflow && workflowset.fuelWorkflow.steps && workflowset.fuelWorkflow.steps.length) {
      privateSteps = findPrivateSteps(privateSteps, workflowset.fuelWorkflow.steps);
    }

    // Once we have all the private steps, return an array of their ids
    return privateSteps.map(step => step.id);
  },

  /** Removes any steps marked as private from a workflow_data object */
  removePrivateStepsFromWorkflowData: (workflowData = {}, privateStepIds = []) => {
    let editedWorkflowData = { ...workflowData };

    if (privateStepIds && privateStepIds.length) {
      Object.keys(editedWorkflowData).forEach(id => {
        if (privateStepIds.includes(id)) {
          delete editedWorkflowData[id];
        }
      });
    }

    return editedWorkflowData;
  },

  /** Removes any steps marked as private from a photo array */
  removePrivateStepsFromPhotos: (photos = [], privateStepIds = []) => {
    if (privateStepIds && privateStepIds.length) return photos.filter(photo => !privateStepIds.includes(photo.step_id));
    return photos;
  },
};

module.exports = utilities;
